import { useSelector } from 'react-redux';
import { ApplicationState } from '@mews-commander/types';
import { Stack } from '@optimus-web/core';
import { getSortedRatesByIds } from '@mews-commander/legacy-entities/src/ducks/rates';
import { SummaryRowBody } from '../../SummaryRow';
import { selectedReservationsGroupedByRateId } from '../../../../../selectors/summary';

interface RatesListProps {
    rateIds: string[];
    scope: string;
}

const RatesList = ({ rateIds, scope }: RatesListProps) => {
    const rates = useSelector((state: ApplicationState) => getSortedRatesByIds(state, { ids: rateIds }));
    const reservationsByRateId = useSelector((state: ApplicationState) =>
        selectedReservationsGroupedByRateId(state, { scope })
    );

    return (
        <Stack vertical spacing="100">
            {rates.map(({ name, id }) => (
                <SummaryRowBody text={name} count={reservationsByRateId[id].length} data-test-rate-id={id} />
            ))}
        </Stack>
    );
};

export default RatesList;
